// extracted by mini-css-extract-plugin
export default {"main":"GenerationPage_main__2wZBx","container":"GenerationPage_container__M8CNd"};